// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__0vKtX","Avatar":"Chip_Avatar__9JMLq","text":"Chip_text__j4Aff","closeButton":"Chip_closeButton__a8CYI"};